import React from 'react';
import PropTypes from 'prop-types';
import CtaLink from 'components/essentials/Cta/CtaLink';
import Checkbox from 'components/consumer/Checkbox';

const NewsletterOptIn = ({ checked, name = 'newsletter_opt_in', onClick }) => (
  <Checkbox
    name={name}
    checked={checked}
    onClick={() => {
      onClick(!checked);
    }}
    size="xs"
    className="mx-0 my-[1.2em]"
  >
    Receive email updates from Joybird (including launch announcements, product
    info, and design inspiration). You can unsubscribe anytime. By signing up,
    you agree to our{' '}
    <CtaLink
      to="/privacy-policy/"
      color="brand"
      hasArrow={false}
      noLinkPadding
      size="xs"
      target="_blank"
    >
      Privacy Policy
    </CtaLink>
    {' | '}
    <CtaLink
      to="/terms-of-use/"
      color="brand"
      hasArrow={false}
      noLinkPadding
      size="xs"
      target="_blank"
    >
      Terms of Use
    </CtaLink>
    .
  </Checkbox>
);

NewsletterOptIn.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default NewsletterOptIn;
